module.exports = __webpack_public_path__ + "static/media/relixjpg1.db997588.svg";